// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"512":"b863eb3d28b545a1","636":"c632485980ff930e"}[chunkId] + ".css";
};